<div class="year-calendar-wrapper">
  <div class="cal-overview-header d-flex justify-content-between">
    <div class="lifecycle-content w-100">
      <h2>Leads Lifecycle</h2>
      <!-- <p class="mt-3 mb-3">
        See Your Latest Overview Of Your
        <span class="italic">INK IN CAPS </span> Leads
      </p> -->
    </div>
    <div class="dropdown">
      <button
        class="btn btn-outline-primary dropdown-toggle d-flex justify-content-between"
        type="button"
        (click)="toggleDropdown()"
      >
        {{ selectedProjectLabel }}
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><path fill="currentColor" d="m12 15l5-5H7z"/></svg>
      </button>

      <ul class="dropdown-menu dropdown-menu-end" [class.show]="isDropdownOpen">
  <li>
    <a
      class="dropdown-item"
      [class.active]="selectedProject === null"
      (click)="selectProject('ALL')"
    >
      All
    </a>
  </li>

  <li>
    <a
      class="dropdown-item"
      [class.active]="selectedProject === 'IIC-LAB'"
      (click)="selectProject('IIC-LAB')"
    >
      IIC-LAB
    </a>
  </li>

  <li>
    <a
      class="dropdown-item"
      [class.active]="selectedProject === 'V-RETAIL'"
      (click)="selectProject('V-RETAIL')"
    >
      V-RETAIL
    </a>
  </li>

  <li>
    <a
      class="dropdown-item"
      [class.active]="selectedProject === 'V-ESTATE'"
      (click)="selectProject('V-ESTATE')"
    >
      V-ESTATE
    </a>
  </li>

  <li>
    <a
      class="dropdown-item"
      [class.active]="selectedProject === 'Outbound'"
      (click)="selectProject('Outbound')"
    >
      Outbound
    </a>
  </li>
      </ul>
  
    </div>

    <hr style="height: 4px" />
  </div>

  <div
    class="overview-header overview-animate d-flex justify-content-between align-items-center mt-3 px-5"
  >
    <!-- LEFT SECTION -->
    <div class="overview-left">
      <h4 class="overview-title mb-3">Overview</h4>

      <div class="overview-cards d-flex gap-3">
        <!-- CARD 1 -->
        <div class="overview-card">
          @if (isOverviewLoading) {
    <div class="shimmer-row mt-3 d-flex align-items-center justify-content-between">
     <div>
      <div class="shimmer shimmer-title"></div>
      <div class="shimmer shimmer-badge mt-2"></div>
      </div>
      <div class="shimmer shimmer-text mt-2"></div>

    </div>
  }
  @else {
          <p class="card-label">Total Leads</p>
          <div
            class="card-value-row d-flex align-items-center justify-content-between"
          >
            <h3 class="card-value">{{ totalLeads }}</h3>
            <span
              class="card-badge"
              [class.badge-up]="totalLeadsChange > 0"
              [class.badge-down]="totalLeadsChange < 0"
              [class.badge-neutral]="totalLeadsChange === 0"
            >
              @if (totalLeadsChange > 0) {
              {{ totalLeadsChange
              }}<svg
                width="26"
                height="16"
                viewBox="0 0 26 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.9297 0.790039L24.245 0.790039V6.32188"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
                <path
                  d="M0.558594 15.0167L10.0329 5.53227L14.77 10.2745L24.2443 0.790039"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
              </svg>

              } @else if (totalLeadsChange < 0) {
              {{ Math.abs(totalLeadsChange) }}
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9297 10.457L14.4521 14.2589L11.129 15.5924"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
                <path
                  d="M0.199861 3.42951L8.18124 6.84678L6.47444 10.8418L14.4558 14.259"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
              </svg>
              } @else { 0 }
            </span>
          </div>
        }
        </div>

        <!-- CARD 2 -->
        <div class="overview-card">
           @if (isOverviewLoading) {
    <div class="shimmer-row mt-3 d-flex align-items-center justify-content-between">
     <div>
      <div class="shimmer shimmer-title"></div>
      <div class="shimmer shimmer-badge mt-2"></div>
      </div>
      <div class="shimmer shimmer-text mt-2"></div>

    </div>
  }
  @else {
          <p class="card-label">In Progress Leads</p>
          <div
            class="card-value-row d-flex align-items-center justify-content-between"
          >
            <h3 class="card-value">{{ inProgressLeads }}</h3>
            <span
              class="card-badge"
              [class.badge-up]="inProgressChange > 0"
              [class.badge-down]="inProgressChange < 0"
              [class.badge-neutral]="inProgressChange === 0"
            >
              @if (inProgressChange > 0) {
              {{ inProgressChange }}
              <svg
                width="26"
                height="16"
                viewBox="0 0 26 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.9297 0.790039L24.245 0.790039V6.32188"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
                <path
                  d="M0.558594 15.0167L10.0329 5.53227L14.77 10.2745L24.2443 0.790039"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
              </svg>

              } @else if (inProgressChange < 0) {
              {{ Math.abs(inProgressChange)
              }}<svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9297 10.457L14.4521 14.2589L11.129 15.5924"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
                <path
                  d="M0.199861 3.42951L8.18124 6.84678L6.47444 10.8418L14.4558 14.259"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
              </svg>
              } @else { 0 }
            </span>
          </div>
        }
        </div>

        <!-- CARD 3 -->
        <div class="overview-card">
           @if (isOverviewLoading) {
    <div class="shimmer-row mt-3 d-flex align-items-center justify-content-between">
     <div>
      <div class="shimmer shimmer-title"></div>
      <div class="shimmer shimmer-badge mt-2"></div>
      </div>
      <div class="shimmer shimmer-text mt-2"></div>

    </div>
  }
  @else {
          <p class="card-label">Lost Leads</p>
          <div
            class="card-value-row d-flex align-items-center justify-content-between"
          >
            <h3 class="card-value">{{ lostLeads }}</h3>
            <span
              class="card-badge"
              [class.badge-up]="lostChange > 0"
              [class.badge-down]="lostChange < 0"
              [class.badge-neutral]="lostChange === 0"
            >
              @if (lostChange > 0) {
              {{ lostChange
              }}<svg
                width="26"
                height="16"
                viewBox="0 0 26 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.9297 0.790039L24.245 0.790039V6.32188"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
                <path
                  d="M0.558594 15.0167L10.0329 5.53227L14.77 10.2745L24.2443 0.790039"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
              </svg>

              } @else if (lostChange < 0) {
              {{ Math.abs(lostChange)
              }}<svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9297 10.457L14.4521 14.2589L11.129 15.5924"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
                <path
                  d="M0.199861 3.42951L8.18124 6.84678L6.47444 10.8418L14.4558 14.259"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
              </svg>
              } @else { 0 }
            </span>
          </div>
        }
        </div>

        <!-- CARD 4 -->
        <div class="overview-card">
           @if (isOverviewLoading) {
    <div class="shimmer-row mt-3 d-flex align-items-center justify-content-between">
     <div>
      <div class="shimmer shimmer-title"></div>
      <div class="shimmer shimmer-badge mt-2"></div>
      </div>
      <div class="shimmer shimmer-text mt-2"></div>

    </div>
  }
  @else {
          <p class="card-label">Completed</p>
          <div
            class="card-value-row d-flex align-items-center justify-content-between"
          >
            <h3 class="card-value">{{ convertedLeads }}</h3>
            <span
              class="card-badge"
              [class.badge-up]="convertedChange > 0"
              [class.badge-down]="convertedChange < 0"
              [class.badge-neutral]="convertedChange === 0"
            >
              @if (convertedChange > 0) {
              {{ convertedChange }}
              <svg
                width="26"
                height="16"
                viewBox="0 0 26 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M17.9297 0.790039L24.245 0.790039V6.32188"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
                <path
                  d="M0.558594 15.0167L10.0329 5.53227L14.77 10.2745L24.2443 0.790039"
                  stroke="#008000"
                  stroke-width="1.58074"
                />
              </svg>

              } @else if (convertedChange < 0) {
              {{ Math.abs(convertedChange) }}
              <svg
                width="16"
                height="18"
                viewBox="0 0 16 18"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M12.9297 10.457L14.4521 14.2589L11.129 15.5924"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
                <path
                  d="M0.199861 3.42951L8.18124 6.84678L6.47444 10.8418L14.4558 14.259"
                  stroke="#D30404"
                  stroke-width="1.02413"
                />
              </svg>

              } @else { 0 }
            </span>
          </div>
        }
        </div>
      </div>
    </div>

    <div class="overview-cal">
      <img
        src="assets/leads/calendar-transparent.png"
        width="420"
        alt=""
      />
    </div>
  </div>

  <div class="year-header mt-4">
    <div class="nav-btn" (click)="goToPreviousYear()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 20 20"
      >
        <path
          fill="#000"
          d="m5.83 9l5.58-5.58L10 2l-8 8l8 8l1.41-1.41L5.83 11H18V9z"
        />
      </svg>
    </div>

    <div class="year-label">
      {{ currentYear }}

      <!-- <img src="../../../../assets/leads/rainbow.png"  alt=""> -->
    </div>

    <div class="nav-btn" (click)="goToNextYear()">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="1.5rem"
        height="1.5rem"
        viewBox="0 0 20 20"
      >
        <path
          fill="#000"
          d="M2 11h12.2l-5.6 5.6L10 18l8-8l-8-8l-1.4 1.4L14.2 9H2z"
        />
      </svg>
    </div>
  </div>

  <!-- Months Grid -->
  <div class="months-grid">
    @for (month of months; track month.monthIndex) {
    <div class="month-card">
      <!-- Top holes row -->
      <div class="card-holes-row mt-2">
        @for (dot of [1,2,3,4,5,6,7,8,9,10,11,12]; track dot) {
        <span class="card-hole"></span>
        }
      </div>

      <!-- Month title -->
      <div class="month-title mt-3">
        <h3>{{ month.monthName }}</h3>
      </div>

      <!-- Stats list -->
      <div class="stats-list mt-3">
        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot total-dot"></span>
            <span class="stat-label ml-2">Total Leads</span>
          </div>
          <span class="stat-value">
            {{ month.totalLeads }}
          </span>
        </div>

        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot assigned-dot"></span>
            <span class="stat-label ml-2">Assigned Leads</span>
          </div>
          <span class="stat-value">
            {{ month.assignedLeads ?? 0 }}
          </span>
        </div>

        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot converted-dot"></span>
            <span class="stat-label ml-2">Converted Leads</span>
          </div>
          <span class="stat-value">
            {{ month.convertedLeads }}
          </span>
        </div>

        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot inprogress-dot"></span>
            <span class="stat-label ml-2">Inprogress Leads</span>
          </div>
          <span class="stat-value">
            {{ month.inProgressLeads }}
          </span>
        </div>

        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot notstarted-dot"></span>
            <span class="stat-label ml-2">Not Started Leads</span>
          </div>
          <span class="stat-value">
            {{ month.notStartedLeads ?? 0 }}
          </span>
        </div>

        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot lost-dot"></span>
            <span class="stat-label ml-2">Lost Leads</span>
          </div>
          <span class="stat-value">
            {{ month.lostLeads }}
          </span>
        </div>

        <div class="stat-row">
          <div class="stat-left">
            <span class="stat-dot unassigned-dot"></span>
            <span class="stat-label ml-2">Unassigned Leads</span>
          </div>
          <span class="stat-value">
            {{ month.unAssignedLeads }}
          </span>
        </div>
      </div>

    </div>
    }
  </div>
</div>
